import {log} from "console";
import {promises} from "fs";
import {promisify} from "util";
import hdapi from "../common/hdapi";
import Converter, {ConverterStates} from "./Converter";
import {execute, buildInputFile, loadImageElement} from "wasm-imagemagick";
import AsyncLimit from "../common/AsyncLimit";

const probe = require("probe-image-size");
const fs = require("fs");

async function myExec(cmd, inputFile, outputFile) {
	// /node_modules/wasm-imagemagick/dist/src/magickApi.js 开发环境下需要更改
	// 1. magickWorker 的else语句 为 magickWorker = new Worker("static/js/magick.js"); 132行
	// 2. magickWorkerUrl 需要修改为 const magickWorkerUrl = GetCurrentUrlDifferentFilename(currentJavascriptURL, 'magick.js');118行
	console.log("cmd", cmd);
	var inext = hdapi.extname(inputFile);
	var outext = hdapi.extname(outputFile);
	var infilename = hdapi.filename(outputFile) + "-1";
	var outfilename = hdapi.filename(outputFile) + "-2";
	var inputURL = await hdapi.readFile(inputFile, "base64");
	inputFile = "data:image/png;base64," + inputURL;
	var infile = infilename + inext;
	var inputFiles = [await buildInputFile(inputFile, infile)];
	const {outputFiles, exitCode, stderr} = await execute({
		inputFiles,
		commands: cmd + ` '${infilename}${inext}' '${outfilename}${outext}'`,
	});
	if (exitCode) {
		// alert(`There was an error with the command: ${stderr.join('\n')}`)
		return console.error("压缩失败");
	} else {
		await hdapi.writeFile(outputFile, Buffer.from(outputFiles[0].buffer));
	}
}

async function beforeExec(file) {
	var inputURL = await hdapi.readFile(file, "base64");
	var inputFile = "data:image/png;base64," + inputURL;
	var inext = hdapi.extname(file);
	var infilename = hdapi.filename(file);
	var infile = new Date().getTime() + inext;
	const {stderr, stdout, exitCode} = await execute({
		inputFiles: [await buildInputFile(inputFile, infile)],
		commands: `identify -verbose ${infile}`,
	});
	if (exitCode) {
		// alert(`There was an error with the command: ${stderr.join('\n')}`)
		console.error("读取信息失败", file, stderr);
	} else {
		// console.log("stdout", stdout);
		return stdout;
	}
}

export default class ImageConverter extends Converter {
	constructor() {
		super();
		this.options = {
			compressLevel: 70, // 50: 缩小优先 85:清晰优先 70:普通压缩
			outputExt: "", // '':格式不变 png|jpg 其它格式
			global_application: false, //是否全局应用高效压缩属性
		};
		this._ysType = "图片压缩";
		this.nowFileArry = [];
		this.isToJpgLimit = 0;
		// this._queue = new AsyncLimit(1);
	}
	async loadFile(path, isAFilePush, url) {
		// console.log("isAFilePush", isAFilePush);
		// console.log("url", url);
		return super.loadFile(path).then((file) => {
			var img = fs.readFileSync(path);
			img = probe.sync(img);
			// console.log("img", img);
			// console.log("file", file);
			if (isAFilePush) {
				file.isAFilePush = isAFilePush;
				file.OriginFilePushPath = url;
			}
			if (img) {
				file.gx_aspect_ratio = 100;
				file.gx_width = img.width;
				file.gx_height = img.height;
				file.gx_compressLevel = 50;
				file.gx_filesize = file.size > 100 * 1024 ? 100 : file.size / 1024;
				file.is_gx_quality = false;
				file.is_gx_resolution = false;
				file.is_gx_filesize = false;
				// file.compressLevel = 85;
				file.width = img.width;
				file.height = img.height;
				file.state = ConverterStates.WAIT;
			} else {
				file.gx_aspect_ratio = 100;
				file.gx_width = 0;
				file.gx_height = 0;
				file.gx_compressLevel = 50;
				file.is_gx_resolution = false;
				file.is_gx_quality = false;
				file.is_gx_filesize = false;
				// file.compressLevel = 85;
				file.width = 0;
				file.height = 0;
				if (file.size > 0) {
					file.state = ConverterStates.WAIT;
					file.gx_filesize = file.size > 100 * 1024 ? 100 : file.size / 1024;
				} else {
					file.state = ConverterStates.BROKE_FILE;
					file.gx_filesize = 0;
				}
			}
			return file;
		});
	}

	async doConvert(file, dir, i) {
		if (i == null) {
			i = "";
			file.filename = hdapi.filename(file.path);
		}
		// console.log("压缩第", i, "次");
		file.ext = file.ext.toLowerCase();
		var ext = this.options.outputExt;
		ext = ext ? "." + ext : hdapi.extname(file.path);
		// var outfile = hdapi.filename(file.path) + `${i}` + ext;
		if (i == "") {
			// console.log("nowFileArry_1", this.nowFileArry);
			if (this.nowFileArry.indexOf(file.filename) == -1) {
				this.nowFileArry.push(file.filename);
				// console.log("nowFileArry_2", this.nowFileArry);
			} else {
				var a = hdapi.extname(file.path).split(".");
				file.filename += `-` + a[1];
				this.checkIsSameFileName(file);
				// this.nowFileArry.push(file.filename);
				// console.log("nowFileArry_3", this.nowFileArry);
			}
			var outfile = file.filename + ext;
		} else {
			var b = file.filename + `-${i}`;
			this.nowFileArry.push(b);
			// console.log("nowFileArry_4", this.nowFileArry);
			var outfile = b + ext;
		}
		// console.log("outfile", outfile);
		if (file.isAFilePush) {
			if (window.store.local.outputOriginDir) {
				file.outpath = hdapi.join(file.outputOriginDir, outfile);
			} else {
				file.outpath = hdapi.join(file.outputCustomDir, outfile);
			}
			// return;
		} else file.outpath = hdapi.join(dir, outfile);
		let exist = await hdapi.exists(`${file.outpath}`);
		if (exist) {
			await this.doConvert(file, dir, i == "" ? 1 : ++i);
		} else {
			if (hdapi.platform == "MAC") {
				// console.log("file.outfile", file.outpath);
				// 如何启用高效压缩设置分辨率
				var str2 =
					".aai,.avif,.avs,.bmp2,bmp3,.cals,.cin,.dcx,.dds,.dib,.fits,.epi,.eps,.eps2,.eps3,.epsf,.epsi,.exr,.farbfeld,.fax,.fl32,.hdr,.hrz,.j2c,.j2k,.jng,.jp2,.mat,.miff,.mng,.mtv,.otb,.pam,.pbm,.pcd,.pcds,.pcx,.pdb,.pfm,.pgm,.phm,.pict,.png00,.png24,.png32,.png48,.png64,.png8,.pnm,.ppm,.ps,.ps2,.psb,.ptif,.sgi,.sun,.tga,.tiff,.vicar,.wbmp,.xbm,.xpm";
				if (
					file.ext != ".gif" &&
					file.ext != ".png" &&
					file.ext != ".bmp" &&
					str2.indexOf(file.ext) == -1
				) {
					let filequality = await beforeExec(file.path);
					// console.log("filequality",filequality);
					// filequality = filequality.stdout.split("\n");
					for (let i = 0; i < filequality.length; i++) {
						let a = filequality[i].search("Quality");
						// console.log("a", a);
						if (a > 0) {
							filequality = filequality[i];
							break;
						}
					}
					filequality = filequality.replace(/\s*/g, "").split(":");
					file.filequality = filequality[filequality.length - 1];
					console.log("Quality", filequality[filequality.length - 1]);
				}
				var resolution_with, resolution_height;
				if (file.is_gx_resolution) {
					resolution_height = file.gx_height;
					resolution_with = file.gx_width;
				} else {
					resolution_with = file.width;
					resolution_height = file.height;
				}
				// 如果启用高效压缩设置压缩参数
				var quality;
				if (file.is_gx_quality) {
					quality = file.gx_compressLevel;
				} else {
					quality = this.options.compressLevel;
				}
				// 当存在文件输出格式不为jpg但是存在设置输出文件大小时
				if (file.ext != ".jpg" && !this.options.outputExt && file.is_gx_filesize) {
					this.isToJpgLimit += 1;
					console.log("isToJpgLimit", this.isToJpgLimit);
				}
				// 打开定时器
				this.setTimeCheckProgress(file);
				//压缩bmp格式、png格式
				var str =
					".BMP2,.BMP3,.DCX,.DIB,.EPDF,.HDR,.ICO,.MIFF,.MNG,.PAM,.PBM,.PCX,.PFM,.PGM,.PHM,.PICT,.PNG,.PNG00,.PNG24,.PNG32,.PNG48,.PNG64,.PNG8,.PNM,.PPM,.PSB,.PSD,.SGI,.SUN,.TGA,.TIFF,.WEBP,.XPM";
				str = str.toLowerCase();
				// console.log("str1 indexof=", str.indexOf(file.ext));
				if (
					(file.ext == ".bmp" && !this.options.outputExt) ||
					(file.ext == ".png" && !this.options.outputExt) ||
					(file.ext == ".webp" && !this.options.outputExt) ||
					(str.indexOf(file.ext) > -1 && !this.options.outputExt)
				) {
					// 根据图片格式调整
					// console.log("str2 indexof=", str.indexOf(file.ext));
					if (file.is_gx_quality) {
						quality = 256 - 2 * file.gx_compressLevel;
					} else {
						switch (this.options.compressLevel) {
							case 85:
								quality = 256;
								break;
							case 70:
								quality = 192;
								break;
							case 50:
								quality = 128;
								break;
						}
					}
					if (resolution_with == 0) {
						return await myExec(
							`convert +dither -strip -colors ${quality} -depth 8`,
							file.path,
							file.outpath
						);
					}
					return await myExec(
						`convert -resize ${resolution_with}x${resolution_height} +dither -strip -colors ${quality} -depth 8`,
						file.path,
						file.outpath
					);
				}
				if (
					(file.ext == ".png" && this.options.outputExt == "jpg") ||
					(file.ext == ".webp" && this.options.outputExt == "jpg")
				) {
					if (resolution_with == 0) {
						if (file.is_gx_filesize) {
							return await myExec(
								`convert -define jpeg:dct-method=float -sampling-factor 4:2:0 -strip -interlace Plane -define jpeg:extent=${file.gx_filesize}kb -quality ${quality} -background white -flatten -alpha off`,
								file.path,
								file.outpath
							);
						}
						return await myExec(
							`convert -define jpeg:dct-method=float -sampling-factor 4:2:0 -strip -interlace Plane -quality ${quality} -background white -flatten -alpha off`,
							file.path,
							file.outpath
						);
					}
					if (file.is_gx_filesize) {
						return await myExec(
							`convert -resize ${resolution_with}x${resolution_height} -define jpeg:dct-method=float -sampling-factor 4:2:0 -strip -interlace Plane -define jpeg:extent=${file.gx_filesize}kb -quality ${quality} -background white -flatten -alpha off`,
							file.path,
							file.outpath
						);
					}
					return await myExec(
						`convert -resize ${resolution_with}x${resolution_height} -define jpeg:dct-method=float -sampling-factor 4:2:0 -strip -interlace Plane -quality ${quality} -background white -flatten -alpha off`,
						file.path,
						file.outpath
					);
				}
				if (file.ext == ".gif" && !this.options.outputExt) {
					if (file.is_gx_quality) {
						quality = 100 - file.gx_compressLevel;
					} else {
						switch (this.options.compressLevel) {
							case 85:
								quality = 10;
								break;
							case 70:
								quality = 30;
								break;
							case 50:
								quality = 50;
								break;
						}
					}
					resolution_with = (resolution_with / file.width) * 100;
					resolution_height = (resolution_height / file.height) * 100;
					return await myExec(
						`convert -resize ${resolution_with}%x${resolution_height}% -strip -fuzz ${quality}% -layers Optimize`,
						file.path,
						file.outpath
					);
				}
				if (file.ext == ".gif" && this.options.outputExt == "jpg") {
					return Promise.reject("GIF to JPG");
				} else {
					quality = this.checkQualityOk(quality, file);
					// console.log("macquality",quality);
					if (this.options.outputExt == "jpg" || file.ext == ".jpg") {
						if (resolution_with == 0) {
							// console.log(`convert -quality ${quality} "${file.path}" "${file.outpath}"`);
							if (file.is_gx_filesize) {
								return await myExec(
									`convert -define jpeg:dct-method=float -sampling-factor 4:2:0 -strip -interlace Plane -define jpeg:extent=${file.gx_filesize}kb -quality ${quality}`,
									file.path,
									file.outpath
								);
							}
							return await myExec(
								`convert -define jpeg:dct-method=float -sampling-factor 4:2:0 -strip -interlace Plane -quality ${quality}`,
								file.path,
								file.outpath
							);
						}
						if (file.is_gx_filesize) {
							return await myExec(
								`convert -resize ${resolution_with}x${resolution_height} -define jpeg:dct-method=float -sampling-factor 4:2:0 -strip -interlace Plane -define jpeg:extent=${file.gx_filesize}kb -quality ${quality}`,
								file.path,
								file.outpath
							);
						}
						return await myExec(
							`convert -resize ${resolution_with}x${resolution_height} -define jpeg:dct-method=float -sampling-factor 4:2:0 -strip -interlace Plane -quality ${quality}`,
							file.path,
							file.outpath
						);
					}
					if (resolution_with == 0) {
						// console.log(`convert -quality ${quality} "${file.path}" "${file.outpath}"`);
						return await myExec(`convert -strip -quality ${quality}`, file.path, file.outpath);
					}
					return await myExec(
						`convert -resize ${resolution_with}x${resolution_height} -strip -quality ${quality}`,
						file.path,
						file.outpath
					);
				}
			} else if (hdapi.platform == "WIN") {
				// 当可以选择质量参数时
				var str2 =
					".aai,.avif,.avs,.bmp2,bmp3,.cals,.cin,.dcx,.dds,.fits,.dib,.epi,.eps,.eps2,.eps3,.epsf,.epsi,.exr,.farbfeld,.fax,.fl32,.hdr,.hrz,.j2c,.j2k,.jng,.jp2,.mat,.miff,.mng,.mtv,.otb,.pam,.pbm,.pcd,.pcds,.pcx,.pdb,.pfm,.pgm,.phm,.pict,.png00,.png24,.png32,.png48,.png64,.png8,.pnm,.ppm,.ps,.ps2,.psb,.ptif,.sgi,.sun,.tga,.tiff,.vicar,.wbmp,.xbm,.xpm";
				if (
					file.ext != ".gif" &&
					file.ext != ".png" &&
					file.ext != ".bmp" &&
					str2.indexOf(file.ext) == -1
				) {
					let filequality = await hdapi.procCreate(
						[`magick`, `identify`, `-verbose`, `${file.path}`],
						{
							spawnMode: false,
						}
					);
					filequality = filequality.stdout.split("\n");
					for (let i = 0; i < filequality.length; i++) {
						let a = filequality[i].search("Quality");
						// console.log("a", a);
						if (a > 0) {
							filequality = filequality[i];
							break;
						}
					}
					filequality = filequality.replace(/\s*/g, "").split(":");
					// console.log("Quality", filequality[filequality.length - 1]);
					file.filequality = filequality[filequality.length - 1];
				}
				// console.log("i", filequality[75], filequality);
				// console.log("file.outfile", file.outpath);
				// 如何启用高效压缩设置分辨率
				var resolution_with, resolution_height;
				if (file.is_gx_resolution) {
					resolution_height = file.gx_height;
					resolution_with = file.gx_width;
				} else {
					resolution_with = file.width;
					resolution_height = file.height;
				}
				// 如果启用高效压缩设置压缩参数
				var quality;
				if (file.is_gx_quality) {
					quality = file.gx_compressLevel;
				} else {
					quality = this.options.compressLevel;
				}
				// 当存在文件输出格式不为jpg但是存在设置输出文件大小时
				if (file.ext != ".jpg" && !this.options.outputExt && file.is_gx_filesize) {
					this.isToJpgLimit += 1;
					console.log("isToJpgLimit", this.isToJpgLimit);
				}
				// 打开定时器
				this.setTimeCheckProgress(file);
				//压缩bmp格式、png格式
				var str =
					".BMP2,.BMP3,.DCX,.DIB,.EPDF,.HDR,.ICO,.MIFF,.MNG,.PAM,.PBM,.PCX,.PFM,.PGM,.PHM,.PICT,.PNG,.PNG00,.PNG24,.PNG32,.PNG48,.PNG64,.PNG8,.PNM,.PPM,.PSB,.PSD,.SGI,.SUN,.TGA,.TIFF,.WEBP,.XPM";
				str = str.toLowerCase();
				// console.log("str1 indexof=", str.indexOf(file.ext));
				if (
					(file.ext == ".bmp" && !this.options.outputExt) ||
					(file.ext == ".png" && !this.options.outputExt) ||
					(file.ext == ".webp" && !this.options.outputExt) ||
					(str.indexOf(file.ext) > -1 && !this.options.outputExt)
				) {
					// 根据图片格式调整
					// console.log("str2 indexof=", str.indexOf(file.ext));
					if (file.is_gx_quality) {
						quality = 256 - 2 * file.gx_compressLevel;
					} else {
						switch (this.options.compressLevel) {
							case 85:
								quality = 256;
								break;
							case 70:
								quality = 192;
								break;
							case 50:
								quality = 128;
								break;
						}
					}
					if (resolution_with == 0) {
						return hdapi.exec(
							`magick convert "${file.path}" +dither -strip -colors ${quality} -depth 8  "${file.outpath}"`
						);
					}
					// console.log(
					// 	`convert -resize ${resolution_with}x${resolution_height} "${file.path}" +dither -strip -colors ${quality} -depth 8  "${file.outpath}"`
					// );
					return hdapi.exec(
						`magick convert -resize ${resolution_with}x${resolution_height} "${file.path}" +dither -strip -colors ${quality} -depth 8  "${file.outpath}"`
					);
				}
				if (
					(file.ext == ".png" && this.options.outputExt == "jpg") ||
					(file.ext == ".webp" && this.options.outputExt == "jpg")
				) {
					if (resolution_with == 0) {
						if (file.is_gx_filesize) {
							return hdapi.exec(
								`magick convert -define jpeg:dct-method=float -sampling-factor 4:2:0 -strip -interlace Plane -define jpeg:extent=${file.gx_filesize}kb -quality ${quality} "${file.path}" -background white -flatten -alpha off "${file.outpath}"`
							);
						}
						return hdapi.exec(
							`magick convert -define jpeg:dct-method=float -sampling-factor 4:2:0 -strip -interlace Plane -quality ${quality} "${file.path}" -background white -flatten -alpha off "${file.outpath}"`
						);
					}
					if (file.is_gx_filesize) {
						return hdapi.exec(
							`magick convert -resize ${resolution_with}x${resolution_height} -define jpeg:dct-method=float -sampling-factor 4:2:0 -strip -interlace Plane -define jpeg:extent=${file.gx_filesize}kb -quality ${quality} "${file.path}" -background white -flatten -alpha off "${file.outpath}"`
						);
					}
					return hdapi.exec(
						`magick convert -resize ${resolution_with}x${resolution_height} -define jpeg:dct-method=float -sampling-factor 4:2:0 -strip -interlace Plane -quality ${quality} "${file.path}" -background white -flatten -alpha off "${file.outpath}"`
					);
				}
				if (file.ext == ".gif" && !this.options.outputExt) {
					if (file.is_gx_quality) {
						quality = 100 - file.gx_compressLevel;
					} else {
						switch (this.options.compressLevel) {
							case 85:
								quality = 10;
								break;
							case 70:
								quality = 30;
								break;
							case 50:
								quality = 50;
								break;
						}
					}
					resolution_with = (resolution_with / file.width) * 100;
					resolution_height = (resolution_height / file.height) * 100;
					// console.log(
					// 	`convert -resize ${resolution_with}%x${resolution_height}% -strip -fuzz ${quality}% -layers Optimize "${file.path}" "${file.outpath}"`
					// );
					return hdapi.exec(
						`magick convert -resize ${resolution_with}%x${resolution_height}% -strip -fuzz ${quality}% -layers Optimize "${file.path}" "${file.outpath}"`
					);
				}
				if (file.ext == ".gif" && this.options.outputExt == "jpg") {
					return Promise.reject("GIF to JPG");
				} else {
					quality = this.checkQualityOk(quality, file);
					if (this.options.outputExt == "jpg" || file.ext == ".jpg") {
						if (resolution_with == 0) {
							// console.log(`convert -quality ${quality} "${file.path}" "${file.outpath}"`);
							if (file.is_gx_filesize) {
								return hdapi.exec(
									`magick convert -define jpeg:dct-method=float -sampling-factor 4:2:0 -strip -interlace Plane -define jpeg:extent=${file.gx_filesize}kb -quality ${quality} "${file.path}" "${file.outpath}"`
								);
							}
							return hdapi.exec(
								`magick convert -define jpeg:dct-method=float -sampling-factor 4:2:0 -strip -interlace Plane -quality ${quality} "${file.path}" "${file.outpath}"`
							);
						}
						if (file.is_gx_filesize) {
							return hdapi.exec(
								`magick convert -resize ${resolution_with}x${resolution_height} -define jpeg:dct-method=float -sampling-factor 4:2:0 -strip -interlace Plane -define jpeg:extent=${file.gx_filesize}kb -quality ${quality} "${file.path}" "${file.outpath}"`
							);
						}
						return hdapi.exec(
							`magick convert -resize ${resolution_with}x${resolution_height} -define jpeg:dct-method=float -sampling-factor 4:2:0 -strip -interlace Plane -quality ${quality} "${file.path}" "${file.outpath}"`
						);
					}
					if (resolution_with == 0) {
						return hdapi.exec(
							`magick convert -strip -quality ${quality} "${file.path}" "${file.outpath}"`
						);
					}
					return hdapi.exec(
						`magick convert -resize ${resolution_with}x${resolution_height} -strip -quality ${quality} "${file.path}" "${file.outpath}"`
					);
				}
			}
		}
	}

	setTimeCheckProgress(file) {
		// let that = this;
		file.progress_time = setInterval(function () {
			// console.log("progress", file.progress);
			if (file.progress < 0.8) file.progress += 0.01;
			if (file.state != 2) {
				file.progress = 0;
				clearInterval(file.progress_time);
			}
		}, 50);
	}

	checkIsSameFileName(file, i) {
		if (!i) i = 1;
		if (this.nowFileArry.indexOf(file.filename) == -1) {
			this.nowFileArry.push(file.filename);
			return;
		} else {
			file.filename = file.filename + `(${i})`;
			this.checkIsSameFileName(file, i);
		}
	}

	checkQualityOk(q, file) {
		if (!file.filequality) {
			return q;
		}
		if (parseInt((q / 100) * file.filequality) >= 5) {
			return parseInt((q / 100) * file.filequality);
		} else return 5;
	}
}
